// import { AgmCoreModule } from '@agm/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PgsSmartTableModule } from '../cdk/pgs-smart-table';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { esLocale } from 'ngx-bootstrap/locale';
import { PrintDirective } from '../shared/print/print.directive';
import { CapitalizePipe } from './capitalize/capitalize.pipe';
import { CustomButtonCellComponent } from './custom-button-cell/custom-button-cell.component';
import { CustomButtonsCellComponent } from './custom-buttons-cell/custom-buttons-cell.component';
import { CustomCheckboxCellComponent } from './custom-checkbox-cell/custom-checkbox-cell.component';
import { CustomClickableCellComponent } from './custom-clickable-cell/custom-clickable-cell.component';
import { CustomDateCellComponent } from './custom-date-cell/custom-date-cell.component';
import { CustomInputCellComponent } from './custom-input-cell/custom-input-cell.component';
import { CustomListCellComponent } from './custom-list-cell/custom-list-cell.component';
import { CustomPriceCellComponent } from './custom-price-cell/custom-price-cell.component';
import { CustomUpdatableCellComponent } from './custom-updatable-cell/custom-updatable-cell.component';
import { ScrollablePaneDirective } from './directives/scrollable-pane.directive';
import { ExcelExportComponent } from './excel-export/excel-export.component';
import { LocalizationPipe } from './localization/localization.pipe';
import { PartialSearchComponent } from './partial-search/partial-search.component';
import { PgsCurrencyPipe } from './pgs-currency/pgs-currency.pipe';
import { RequiredFieldDirective } from './required-field/required-field.directive';
import { CustomToastComponent } from './toastr/custom-toast.component';
import { WizardModule } from './wizard/wizard.module';
import { environment } from '../../environments/environment';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BlockCopyPasteDirective } from './directives/appBlockCopyPaste.directive';
import { PgsInputFilterDirective } from './directives/pgs-input-filter.directive';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { PgsNumberFilterDirective } from './directives/pgs-number-filter.directive';
import { PgsInputContratistaDirective } from './directives/pgs-input-contratista.directive';
import { PgsRutFormatDirective } from './directives/pgs-rut-format.directive';
import { ThousandsPipePipe } from './validators/thousands-pipe.pipe';
import { PgsTooltipDirective } from './directives/pgs-tooltip.directive';
import { CustomModalModule } from './custom-modal/custom-modal.module';
import {PgsPaginatorModule} from './pipes/pgs-paginator/pgs-paginator.module';
// import { CustomSelectComponent } from './custom-select/component/custom-select.component';
import { CustomSelectModule } from '../core/custom-select/custom-select.module';
import { PgsToastComponent } from './pgs-toast/component/pgs-toast.component';
import { PgsDateModule } from './pipes/pgs-date/pgs-date.module';
import { PgsSelectSearchModule } from '../cdk/pgs-select-search/pgs-select-search.module';
import { CurrencyMaskDirective } from './directives/currency-mask.directive';


defineLocale('es-lang', esLocale);

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        PgsSelectSearchModule,
        FormsModule,
        ReactiveFormsModule,
        PgsSmartTableModule,
        NgxDatatableModule,
        NgxBarcode6Module,
        CustomModalModule,
        PgsPaginatorModule,
        BsDatepickerModule.forRoot(),
        WizardModule,
        PgsDateModule,
        // AgmCoreModule.forRoot({
        //   apiKey: environment.googleApiKey
        // })
    ],
    exports: [
        // AgmCoreModule,
        PartialSearchComponent,
        CommonModule,
        NgbModule,
        ScrollablePaneDirective,
        CurrencyMaskDirective,
        ExcelExportComponent,
        ReactiveFormsModule,
        PgsSmartTableModule,
        NgxDatatableModule,
        FormsModule,
        BsDatepickerModule,
        WizardModule,
        LocalizationPipe,
        RequiredFieldDirective,
        PgsCurrencyPipe,
        CustomToastComponent,
        CapitalizePipe,
        PrintDirective,
        BlockCopyPasteDirective,
        PgsInputFilterDirective,
        PgsNumberFilterDirective,
        CustomModalModule,
        PgsTooltipDirective,
        PgsInputContratistaDirective,
        PgsPaginatorModule,
        CustomSelectModule,
        PgsDateModule,
        PgsRutFormatDirective,
    ],
    declarations: [
        PartialSearchComponent,
        CustomButtonCellComponent,
        CustomInputCellComponent,
        CustomPriceCellComponent,
        CustomButtonsCellComponent,
        CustomClickableCellComponent,
        CustomUpdatableCellComponent,
        ScrollablePaneDirective,
        CurrencyMaskDirective,
        CustomDateCellComponent,
        CustomCheckboxCellComponent,
        CustomListCellComponent,
        ExcelExportComponent,
        LocalizationPipe,
        RequiredFieldDirective,
        PgsCurrencyPipe,
        CustomToastComponent,
        CapitalizePipe,
        PrintDirective,
        BlockCopyPasteDirective,
        PgsInputFilterDirective,
        PgsNumberFilterDirective,
        PgsInputContratistaDirective,
        ThousandsPipePipe,
        PgsTooltipDirective,
        PgsToastComponent,
        PgsRutFormatDirective
    ],
    providers: [
        CurrencyPipe
    ]
})
export class SharedModule { }
